import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrustSignals = ({ certifications, clientLogos, metrics }) => {
  return (
    <div className="bg-muted/20 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Certifications */}
        <div className="text-center mb-16">
          <h2 className="text-2xl font-bold text-foreground mb-8">Certifications & Compliance</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {certifications?.map((cert, index) => (
              <div key={index} className="flex flex-col items-center space-y-3">
                <div className="w-16 h-16 bg-card border border-border rounded-xl flex items-center justify-center shadow-subtle">
                  <Icon name={cert?.icon} size={24} className="text-primary" />
                </div>
                <div className="text-center">
                  <div className="font-medium text-foreground text-sm">{cert?.name}</div>
                  <div className="text-xs text-muted-foreground">{cert?.description}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Client Logos */}
        <div className="text-center mb-16">
          <h2 className="text-2xl font-bold text-foreground mb-8">Trusted by Leading Organizations</h2>
          <div className="grid grid-cols-3 md:grid-cols-6 gap-8 items-center">
            {clientLogos?.map((client, index) => (
              <div key={index} className="flex items-center justify-center p-4 bg-card border border-border rounded-lg hover:shadow-subtle transition-smooth">
                <Image
                  src={client?.logo}
                  alt={client?.name}
                  className="max-w-full max-h-12 object-contain opacity-70 hover:opacity-100 transition-opacity"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Success Metrics */}
        <div className="bg-card border border-border rounded-2xl p-8">
          <h2 className="text-2xl font-bold text-foreground text-center mb-8">Our Track Record</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {metrics?.map((metric, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name={metric?.icon} size={24} className="text-primary" />
                </div>
                <div className="text-3xl font-bold text-primary mb-2">{metric?.value}</div>
                <div className="text-sm font-medium text-foreground mb-1">{metric?.label}</div>
                <div className="text-xs text-muted-foreground">{metric?.description}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Security & Compliance */}
        <div className="mt-16 bg-gradient-to-r from-primary/5 to-accent/5 rounded-2xl p-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-foreground mb-4">Security & Compliance</h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              Your data and systems are protected by industry-leading security measures and compliance standards
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-card border border-border rounded-lg p-6 text-center">
              <Icon name="Shield" size={32} className="text-success mx-auto mb-4" />
              <h3 className="font-semibold text-foreground mb-2">Data Protection</h3>
              <p className="text-sm text-muted-foreground">
                End-to-end encryption and secure data handling protocols
              </p>
            </div>
            
            <div className="bg-card border border-border rounded-lg p-6 text-center">
              <Icon name="Lock" size={32} className="text-success mx-auto mb-4" />
              <h3 className="font-semibold text-foreground mb-2">Access Control</h3>
              <p className="text-sm text-muted-foreground">
                Multi-factor authentication and role-based permissions
              </p>
            </div>
            
            <div className="bg-card border border-border rounded-lg p-6 text-center">
              <Icon name="FileCheck" size={32} className="text-success mx-auto mb-4" />
              <h3 className="font-semibold text-foreground mb-2">Compliance</h3>
              <p className="text-sm text-muted-foreground">
                Adherence to local and international regulatory standards
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;